import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { PageShell } from '@/components/layout/PageShell'

const NotFound = () => {
	const location = useLocation()

	useEffect(() => {
		console.error('404 Error: User attempted to access non-existent route:', location.pathname)
	}, [location.pathname])

	return (
		<PageShell centered className='py-24'>
			<h1 className='text-4xl font-extrabold tracking-[-0.21px] text-foreground sm:text-5xl'>404</h1>
			<p className='text-sm text-muted-foreground'>Oops! This market doesn't exist.</p>
			<Link to='/' className='mt-2 rounded-lg bg-success px-4 py-2 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90'>
				Back to Markets
			</Link>
		</PageShell>
	)
}

export default NotFound
